import React from 'react';

const SubFieldFilename = () => {
  return (
    <div>
      <h4>Subfield [filename]</h4>
      <p>
        Name of the file
      </p>
      <p>
        <strong>MANDATORY: MUST</strong> match the actual filename stored in the same directory as the XML file
      </p>
      <div>
        Example:
      </div>
      <pre>
        <code className="language-xml">
          {`<recall lang="en" xmlns="urn:recall-schema">
  <image>
    <filename>Dolphin1.jpg</filename>
    ...
  </image>
  <image>
    <filename>Dolphin2.jpg</filename>
    ...
  </image>
  ...
</recall>
`}
        </code>
      </pre>
    </div>
  );
};

export default SubFieldFilename;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/complex-field-images/subfield-filename.js